import React from 'react';
import {
  ShieldAlert,
  Camera,
  Plane,
  Monitor,
  Network,
  Truck,
  KeyRound,
  Cctv,
  BrainCircuit,
  Radar,
  LineChart,
  Radio,
  Crosshair,
  Route,
  Globe,
  LucideProps,
} from 'lucide-react';

const iconMap: Record<string, React.ComponentType<LucideProps>> = {
  ShieldAlert,
  Camera,
  Plane,
  Monitor,
  Network,
  Truck,
  KeyRound,
  Cctv,
  BrainCircuit,
  Radar,
  LineChart,
  Radio,
  Crosshair,
  Route,
  Globe,
};

interface IconProps extends LucideProps {
  name: string;
}

// Renders a lucide icon by its name (used with the `icon` field in services.ts).
const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  const Cmp = iconMap[name] ?? ShieldAlert;
  return <Cmp {...props} />;
};

export default Icon;
